module.exports = __webpack_public_path__ + "static/media/present.1ec8f08c.png";